
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class AccountingPeriodGrid extends _Ext.GridBase<AccountingPeriodRow, any> {
        protected getColumnsKey() { return 'Finance.AccountingPeriod'; }
        protected getDialogType() { return AccountingPeriodDialog; }
        protected getIdProperty() { return AccountingPeriodRow.idProperty; }
        protected getInsertPermission() { return AccountingPeriodRow.insertPermission; }
        protected getLocalTextPrefix() { return AccountingPeriodRow.localTextPrefix; }
        protected getService() { return AccountingPeriodService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}